<router-outlet></router-outlet>

<app-global-modal />
<app-toast />
